module.exports = __webpack_public_path__ + "img/Outro_Background.e71bc026.jpg";